import React from "react";
import "./Bischofia.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola.jsx";
import Russeliaimages from "../../Media/CGB/Russelia/Russelia.js";
import Daniellaimages from "../../Media/CGB/Daniella/Daniella.js";
import Raveniaimages from "../../Media/CGB/Ravenia/Ravenia.js";
import Calliandraimages from "../../Media/CGB/Caliandra/Caliandra.js";
import Celosiimages from "../../Media/CGB/Celosia/Celosia.js";

const imageMap = {
  Russeliaimages,
  Daniellaimages,
  Raveniaimages,
  Calliandraimages,
  Celosiimages,
};

const produk = () => {
  return (
    <div id="bischofia" className="produk">
      <h1>Cluster Bischofia</h1>
      <h2>Cicilan Start From 6 Juta/Bulan</h2>
      <div className="cardhome-containerb">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
